import {isBoolean} from "lodash/lang";

export default {
    state: {
        isJuridicalPerson: false
    },
    getters: {
        isJuridicalPerson: (state) => state.isJuridicalPerson,
    },
    mutations: {
        setIsJuridicalPerson(state, val) {
            isBoolean(val) && (state.isJuridicalPerson = val)
        },
    }
}
